let Vue = require('vue');
let Promise = require('bluebird');
let quickCustomer = require('sci/ui/quick-customer');

Vue.directive('quick-view-customer', {
    priority: 1000,

    bind: function () {
        quickCustomer($(this.el).addClass('quick-view-customer').parent());
    },
    update: function (value) {

    },
    unbind: function () {
        //$(this.el).off().select2('destroy')
    }
});




// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/components/quick-view-customer.js